export function kebabCase(str: string): string {
  return str.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);
}

export function escapePropertyName(name: string): string {
  return name.replace(/[^\w-]/g, (match) => `\\${match}`);
}

/**
 * Set the opacity of a hex color string.
 *
 * @param color Hex color string
 * @param opacity Opacity value between 0 and 1
 * @returns
 */
export function opacify(color: string, opacity: number): string {
  return (
    color.slice(0, 7) +
    Math.round(opacity * 255)
      .toString(16)
      .padStart(2, '0')
  );
}
